<template>
  <div class="actions">
    <ui-button
      v-if="showUseTemplates"
      shadow
      icon="icon-template"
      @click="$emit('use-template')"
      >{{ $t("message.reviews.replyTemplates.useTemplate") }}</ui-button
    >
    <ui-button
      color="primary"
      outlined
      icon="mdi-reply"
      @click="$emit('reply')"
      >{{ $t("message.reviews.answerBtn") }}</ui-button
    >
  </div>
</template>

<script>
export default {
  name: "QaListItemNormalActions",
  props: {
    showUseTemplates: {
      type: Boolean,
      required: false
    }
  }
};
</script>
<style lang="scss" scoped>
.actions {
  display: flex;
  align-items: center;
  gap: $spacing * 1.25;
}
</style>
